import React, { useEffect, useState } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { endImpersonation } from '../../services/api';
import './ImpersonationBanner.css';

/**
 * Полоса «вы смотрите чужую организацию», видимая супер-админу на всех экранах
 * приложения. Без неё режим просмотра опасен: страницы выглядят точно так же,
 * как свои, и легко забыть, чьи данные перед тобой.
 */
const ImpersonationBanner = () => {
  const { impersonation } = useAuth();
  const [leaving, setLeaving] = useState(false);

  // Класс на body сдвигает контент и липкую шапку из-под фиксированной полосы.
  // Именно сдвигает, а не перекрывает: .navbar сидит на z-index 900 и её
  // выпадающее меню рисуется поверх — накрыть её полосой значит потерять клики.
  useEffect(() => {
    document.body.classList.toggle('impersonating', !!impersonation);
    return () => document.body.classList.remove('impersonating');
  }, [impersonation]);

  if (!impersonation) return null;

  const handleExit = async () => {
    setLeaving(true);
    try {
      const data = await endImpersonation();
      window.location.href = data.platform_url || '/login';
    } catch (e) {
      // Сессия всё равно уже могла быть очищена — уводим на логин,
      // чтобы не оставлять пользователя в непонятном состоянии.
      window.location.href = '/login';
    }
  };

  return (
    <div className="impersonation-banner" role="status">
      <span className="impersonation-banner-badge">Режим просмотра</span>
      <span className="impersonation-banner-text">
        {impersonation.org_name && <strong>{impersonation.org_name}</strong>}
        {impersonation.org_name && ' — '}
        приложение показано глазами «{impersonation.user_name}». Изменение данных отключено.
      </span>
      <button
        type="button"
        className="impersonation-banner-exit"
        onClick={handleExit}
        disabled={leaving}
      >
        {leaving ? 'Выходим…' : 'Выйти из просмотра'}
      </button>
    </div>
  );
};

export default ImpersonationBanner;
